import { render, staticRenderFns } from "./KedvezmenyekB6.vue?vue&type=template&id=1bbd5cfa&"
import script from "./KedvezmenyekB6.vue?vue&type=script&lang=js&"
export * from "./KedvezmenyekB6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports